import React, {Fragment} from "react";
import PropTypes from "prop-types";
import {FaSolidIcon} from "../../../../components/FontAwesomeIcons";
import ModalPortalHOC from "../../../../components/BaseComponents/ModalPortalHOC";
import {ModuloHRAPI} from "../../../../api/ModuloHR/ModuloHRAPI";
import SelfCareDipendenteModal from "../ModuloHR/TimeoffRequests/SelfCareDipendenteModal";
import {AppIconThumbnail} from "../../../../components/BaseComponents/AppIconThumbnail";
import AppConfig from "../../../../config/AppConfig";
import ClockingSessionsView from "../ModuloHR/TimeoffRequests/ClockingSessionsView";

export class StaffMemberAreaButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pageOpen: false,
            staffList: [],
            staffLoading: true
        };
    }

    componentDidMount() {
        ModuloHRAPI.Staff.list()
            .then(staffList => {
                this.setState({staffList: staffList || [], staffLoading: false});
            })
            .catch(_ => {
                this.setState({staffList: [], staffLoading: false});
            });
    }

    handlePageOpen = _ => this.setState({pageOpen: true});
    handlePageClose = _ => this.setState({pageOpen: false});

    render() {
        if (this.state.staffLoading || !this.state.staffList.length) return '';

        return (
            <Fragment>
                <div className={"container mt-3"}>
                    <div className={"bg-white shadow-sm rounded py-2 text-primary"}>
                        <div className={"d-flex align-items-center justify-content-center"} onClick={this.handlePageOpen}>
                            <FaSolidIcon name={"user"}/>
                            <div className={"mx-2"}>Area dipendente</div>
                            <FaSolidIcon name={"chevron-right"}/>
                        </div>
                        <ClockingSessionsView
                            staffList={this.state.staffList}
                        />
                    </div>
                </div>
                <ModalPortalHOC>
                    {
                        this.state.pageOpen &&
                        <SelfCareDipendenteModal
                            staffList={this.state.staffList}
                            onDismiss={this.handlePageClose}
                            active={this.state.pageOpen}
                        />
                    }
                </ModalPortalHOC>
            </Fragment>
        );
    }
}

StaffMemberAreaButton.propTypes = {
    user: PropTypes.object.isRequired
};
